import React, { useState, useEffect } from 'react';
import { 
  Box, Typography, Button, Paper, Grid, Card, CardContent, Dialog, DialogTitle, 
  DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel, 
  List, ListItem, ListItemText, ListItemAvatar, Avatar, IconButton, TextField, Autocomplete,
  Switch, FormControlLabel,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, InputAdornment, Grow, Stack, Divider,
  Tabs, Tab, Chip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import FilterListIcon from '@mui/icons-material/FilterList';
import axios from 'axios';
import API_URL from '../config';
import * as XLSX from 'xlsx';
import { MapContainer, TileLayer, Marker, useMapEvents, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import { useNavigate } from 'react-router-dom';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function LocationMarker({ position, setPosition }) {
  const map = useMapEvents({
    click(e) {
      if (setPosition) {
          setPosition(e.latlng);
          map.flyTo(e.latlng, map.getZoom());
      }
    },
  });

  return position ? <Marker position={position} /> : null;
}

// Format a date (YYYY-MM-DD) + time (HH:MM:SS) into MM/DD/YYYY HH:MM AM/PM.
function formatBCDateTime(dateStr, timeStr) {
  if (!dateStr || !timeStr || timeStr === '-') return '';
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hh, mm] = timeStr.split(':').map(Number);
  let hour12 = hh % 12;
  if (hour12 === 0) hour12 = 12;
  const ampm = hh < 12 ? 'AM' : 'PM';
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(m)}/${pad(d)}/${y} ${pad(hour12)}:${pad(mm)} ${ampm}`;
}

function parseCoordinates(str) {
  if (!str || typeof str !== 'string') return null;
  const parts = str.split(',');
  if (parts.length !== 2) return null;
  const lat = parseFloat(parts[0].trim());
  const lng = parseFloat(parts[1].trim());
  if (isNaN(lat) || isNaN(lng)) return null;
  return { lat, lng };
}

function coordMatchesLocation(coordStr, lat, lng) {
  const coords = parseCoordinates(coordStr);
  if (!coords || lat == null || lng == null) return false;
  const dLat = (coords.lat - lat) * 111320;
  const dLng = (coords.lng - lng) * (111320 * Math.cos(lat * Math.PI / 180));
  return Math.sqrt(dLat * dLat + dLng * dLng) <= 200;
}

function MapResizer() {
  const map = useMap();
  useEffect(() => {
    const timer = setTimeout(() => map.invalidateSize(), 200);
    return () => clearTimeout(timer);
  }, [map]);
  return null;
}

function Punching() {
  const [locations, setLocations] = useState([]);
  const [punchLocations, setPunchLocations] = useState([]); // reusable locations
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [countryFilter, setCountryFilter] = useState('');
  const [locationFilter, setLocationFilter] = useState('');
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedPunchLocations, setSelectedPunchLocations] = useState([]);
  const [newLocation, setNewLocation] = useState({ lat: 25.0, lng: 45.0 }); // Default
  const [address, setAddress] = useState('');
  const [userPunchingId, setUserPunchingId] = useState('');
  const [assignMode, setAssignMode] = useState('select'); // 'select' = pick existing, 'custom' = drop pin

  // --- Manage Locations state ---
  const [manageOpen, setManageOpen] = useState(false);
  const [manageTab, setManageTab] = useState(0); // 0 = list, 1 = add/edit
  const [editingPunchLoc, setEditingPunchLoc] = useState(null);
  const [punchLocForm, setPunchLocForm] = useState({
    name: '',
    latitude: 25.0,
    longitude: 45.0,
    address: ''
  });

  // --- Attendance tab state ---
  const [activeTab, setActiveTab] = useState(0); // 0 = Assignments, 1 = Attendance
  const [attendance, setAttendance] = useState([]);
  const [attendanceLoading, setAttendanceLoading] = useState(false);

  // --- Audit tab state ---
  const [audit, setAudit] = useState([]);
  const [auditLoading, setAuditLoading] = useState(false);

  const [mapDialog, setMapDialog] = useState(null); // { lat, lng, label }

  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('asc');

  const [editOpen, setEditOpen] = useState(false);
  const [editData, setEditData] = useState({
      id: null,
      date: '',
      check_in: '',
      check_in_location: '',
      use_assigned_in: false,
      selectedAssignedIn: '',
      check_out: '',
      check_out_location: '',
      use_assigned_out: false,
      selectedAssignedOut: '',
      effective_lat: null,
      effective_lng: null
  });
  const [updating, setUpdating] = useState(false);
  const [editUserLocations, setEditUserLocations] = useState([]);
  const [addPunchOpen, setAddPunchOpen] = useState(false);
  const [addPunchData, setAddPunchData] = useState({
      user_id: null,
      date: '',
      check_in: '',
      check_in_location: '',
      use_assigned_in: false,
      selectedAssignedIn: '',
      check_out: '',
      check_out_location: '',
      use_assigned_out: false,
      selectedAssignedOut: ''
  });
  const [addPunchUserLocations, setAddPunchUserLocations] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchData = async () => {
    try {
      const [locRes, punchRes, userRes] = await Promise.all([
        axios.get(`${API_URL}/punching/locations`, { headers }),
        axios.get(`${API_URL}/punching/punch-locations`, { headers }),
        axios.get(`${API_URL}/punching/users`, { headers })
      ]);
      setLocations(locRes.data);
      setPunchLocations(punchRes.data);
      setUsers(userRes.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // --- Assignment save ---
  const handleSave = async () => {
    if (!selectedUser) return alert('Select a user');
    if (assignMode === 'select' && selectedPunchLocations.length === 0) return alert('Select at least one location');

    setLoading(true);
    try {
        if (assignMode === 'select') {
            for (const ploc of selectedPunchLocations) {
                await axios.post(`${API_URL}/punching/locations`, {
                    user_id: selectedUser.id,
                    userpunchingid: userPunchingId,
                    location_id: ploc.id,
                    address: address
                }, { headers });
            }
        } else {
            await axios.post(`${API_URL}/punching/locations`, {
                user_id: selectedUser.id,
                userpunchingid: userPunchingId,
                latitude: newLocation.lat,
                longitude: newLocation.lng,
                address: address
            }, { headers });
        }

        setOpen(false);
        fetchData();
        setSelectedUser(null);
        setSelectedPunchLocations([]);
        setAddress('');
        setUserPunchingId('');
        setAssignMode('select');
    } catch (err) {
        alert('Error saving location');
    } finally {
        setLoading(false);
    }
  };

  const handleDelete = async (id) => {
      if(!window.confirm('Delete this location assignment?')) return;
      try {
          await axios.delete(`${API_URL}/punching/locations/${id}`, { headers });
          fetchData();
      } catch (err) {
          alert('Error deleting');
      }
  };

  const handleUserClick = (userId) => {
      navigate(`/punching/${userId}`);
  };

  // --- Punch Location management ---
  const handleOpenManage = () => {
    setManageTab(0);
    setEditingPunchLoc(null);
    setPunchLocForm({ name: '', latitude: 25.0, longitude: 45.0, address: '' });
    setManageOpen(true);
  };

  const handleEditPunchLoc = (ploc) => {
    setEditingPunchLoc(ploc);
    setPunchLocForm({
      name: ploc.name,
      latitude: ploc.latitude,
      longitude: ploc.longitude,
      address: ploc.address || ''
    });
    setManageTab(1);
  };

  const handleSavePunchLocation = async () => {
    const { name, latitude, longitude, address } = punchLocForm;
    if (!name.trim()) return alert('Location name is required');

    try {
      if (editingPunchLoc) {
        await axios.put(`${API_URL}/punching/punch-locations/${editingPunchLoc.id}`, {
          name, latitude, longitude, address
        }, { headers });
      } else {
        await axios.post(`${API_URL}/punching/punch-locations`, {
          name, latitude, longitude, address
        }, { headers });
      }
      setEditingPunchLoc(null);
      setPunchLocForm({ name: '', latitude: 25.0, longitude: 45.0, address: '' });
      fetchData();
      setManageTab(0);
    } catch (err) {
      alert('Error saving punch location');
    }
  };

  const handleDeletePunchLocation = async (id) => {
    if (!window.confirm('Delete this location? Assigned users will keep their assignment but lose the location reference.')) return;
    try {
      await axios.delete(`${API_URL}/punching/punch-locations/${id}`, { headers });
      fetchData();
    } catch (err) {
      alert('Error deleting');
    }
  };

  const allCountries = [...new Set(locations.flatMap(loc => loc.countries || []))].sort();
  const allLocationNames = [...new Set(locations.map(loc => loc.punch_location_name).filter(Boolean))].sort();

  // Group locations by user so each user appears once with all their locations.
  const userGroups = locations.reduce((acc, loc) => {
      if (!acc[loc.user_id]) {
          acc[loc.user_id] = {
              user_id: loc.user_id,
              user_name: loc.user_name,
              userpunchingid: loc.userpunchingid,
              countries: loc.countries || [],
              locations: []
          };
      }
      acc[loc.user_id].locations.push(loc);
      return acc;
  }, {});

  const filteredLocations = Object.values(userGroups).filter(group => {
      const t = searchTerm.toLowerCase();
      const matchesSearch =
          !searchTerm ||
          (group.user_name && group.user_name.toLowerCase().includes(t)) ||
          group.locations.some(loc =>
              (loc.address && loc.address.toLowerCase().includes(t)) ||
              (loc.punch_location_name && loc.punch_location_name.toLowerCase().includes(t))
          );
      const matchesCountry = !countryFilter || group.locations.some(loc => (loc.countries || []).includes(countryFilter));
      const matchesLocation = !locationFilter || group.locations.some(loc => loc.punch_location_name === locationFilter);
      return matchesSearch && matchesCountry && matchesLocation;
  });

  const getFilteredAttendance = async () => {
      const params = new URLSearchParams();
      if (filterFrom) params.append('from', filterFrom);
      if (filterTo) params.append('to', filterTo);
      const qs = params.toString();
      const res = await axios.get(`${API_URL}/punching/attendance${qs ? '?' + qs : ''}`, { headers });

      let rows = res.data || [];
      if (countryFilter) {
          rows = rows.filter(r => (r.countries || []).includes(countryFilter));
      }
      if (locationFilter) {
          rows = rows.filter(r => r.punch_location_name === locationFilter);
      }
      if (searchTerm) {
          const t = searchTerm.toLowerCase();
          rows = rows.filter(r =>
              (r.user_name && r.user_name.toLowerCase().includes(t)) ||
              (r.address && r.address.toLowerCase().includes(t)) ||
              (r.punch_location_name && r.punch_location_name.toLowerCase().includes(t))
          );
      }
      return rows;
  };

  const handleExport = async () => {
      try {
          const rows = await getFilteredAttendance();

          const hdrs = ["Date", "In Time", "In Location", "In On Location", "Out Time", "Out Location", "Out On Location", "Status", "User", "Punching ID", "Location", "Address"];
          const esc = (v) => `"${(v == null ? '' : String(v)).replace(/"/g, '""')}"`;
          const csvContent = [
              hdrs.join(','),
              ...rows.map(r => [
                  esc(r.date),
                  esc(r.check_in),
                  esc(r.check_in_location),
                  (r.check_in_on_site === true ? 'On Location' : (r.check_in_on_site === false ? 'Off Location' : '')),
                  esc(r.check_out),
                  esc(r.check_out_location),
                  (r.check_out_on_site === true ? 'On Location' : (r.check_out_on_site === false ? 'Off Location' : '')),
                  (r.check_out && r.check_out !== '-') ? 'Completed' : 'Active',
                  esc(r.user_name),
                  esc(r.userpunchingid),
                  esc(r.punch_location_name),
                  esc(r.address)
              ].join(','))
          ].join('\n');

          const blob = new Blob([csvContent], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `Punching_Attendance${filterFrom ? '_' + filterFrom : ''}${filterTo ? '_to_' + filterTo : ''}.csv`;
          a.click();
      } catch (err) {
          console.error(err);
          alert('Failed to export attendance data.');
      }
  };

  const handleExportBC = async () => {
      try {
          const rows = await getFilteredAttendance();

          const aoa = [
              ["AC-No.", "No.", "Name", "Time", "State", "New State", "Exception", "Operation"]
          ];

          rows.forEach(r => {
              if (r.check_in && r.check_in !== '-') {
                  aoa.push([r.userpunchingid || '', '', r.user_name || '', formatBCDateTime(r.date, r.check_in), 'C/In', '', 'OK', '']);
              }
              if (r.check_out && r.check_out !== '-') {
                  aoa.push([r.userpunchingid || '', '', r.user_name || '', formatBCDateTime(r.date, r.check_out), 'C/Out', '', 'OK', '']);
              }
          });

          const ws = XLSX.utils.aoa_to_sheet(aoa);
          ws['!cols'] = [
              { wch: 14 }, // AC-No.
              { wch: 6 },  // No.
              { wch: 26 }, // Name
              { wch: 24 }, // Time
              { wch: 8 },  // State
              { wch: 10 }, // New State
              { wch: 10 }, // Exception
              { wch: 10 }  // Operation
          ];

          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Attendance');
          XLSX.writeFile(wb, `Punching_BC${filterFrom ? '_' + filterFrom : ''}${filterTo ? '_to_' + filterTo : ''}.xlsx`);
      } catch (err) {
          console.error(err);
          alert('Failed to export BC data.');
      }
  };

  const clearFilters = () => {
      setSearchTerm('');
      setCountryFilter('');
      setLocationFilter('');
      setFilterFrom('');
      setFilterTo('');
  };

  const fetchAttendance = async () => {
      if (activeTab !== 1) return;
      setAttendanceLoading(true);
      try {
          const rows = await getFilteredAttendance();
          setAttendance(rows);
      } catch (err) {
          console.error(err);
      } finally {
          setAttendanceLoading(false);
      }
  };

  const fetchAudit = async () => {
      if (activeTab !== 2) return;
      setAuditLoading(true);
      try {
          const res = await axios.get(`${API_URL}/punching/audit`, { headers });
          setAudit(res.data);
      } catch (err) {
          console.error(err);
      } finally {
          setAuditLoading(false);
      }
  };

  useEffect(() => {
      if (activeTab === 1) {
          fetchAttendance();
      }
  }, [activeTab, filterFrom, filterTo, countryFilter, locationFilter, searchTerm]);

  useEffect(() => {
      if (activeTab === 2) {
          fetchAudit();
      }
  }, [activeTab]);

  const renderOnSite = (val, name) => {
      if (val === true) return <Chip label={name || 'On Location'} size="small" sx={{ bgcolor: '#dcfce7', color: '#15803d', fontSize: '0.7rem', height: 22, fontWeight: 'bold' }} />;
      if (val === false) return <Chip label="Off Location" size="small" sx={{ bgcolor: '#fee2e2', color: '#b91c1c', fontSize: '0.7rem', height: 22, fontWeight: 'bold' }} />;
      return <Typography variant="body2" color="text.secondary">—</Typography>;
  };

  const formatAuditDate = (iso) => {
      if (!iso) return '—';
      // Stored timestamps are naive UTC — append 'Z' so JS converts to local time.
      const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(iso);
      const d = new Date(hasTz ? iso : iso + 'Z');
      const fallback = new Date(iso);
      const valid = isNaN(d.getTime()) ? fallback : d;
      if (isNaN(valid.getTime())) return iso;
      return valid.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const auditActionLabel = (action) => ({
      'ADD_PUNCH': 'Add Punch',
      'EDIT_PUNCH': 'Edit Punch',
      'ASSIGN_LOCATION': 'Assign Location',
      'UPDATE_LOCATION': 'Update Location',
      'DELETE_LOCATION': 'Delete Location'
  }[action] || action);

  const auditActionColor = (action) => ({
      'ADD_PUNCH': 'success',
      'EDIT_PUNCH': 'info',
      'ASSIGN_LOCATION': 'primary',
      'UPDATE_LOCATION': 'warning',
      'DELETE_LOCATION': 'error'
  }[action] || 'default');

  const renderAuditDetails = (details) => {
      if (!details || typeof details !== 'object') return '—';
      const fieldLabel = {
          'user': 'User', 'date': 'Date', 'check_in': 'In Time', 'check_in_location': 'In Location',
          'check_out': 'Out Time', 'check_out_location': 'Out Location', 'location': 'Location',
          'address': 'Address', 'latitude': 'Latitude', 'longitude': 'Longitude', 'userpunchingid': 'Punching ID'
      };
      const fmt = (v) => (v == null || v === '' ? '—' : String(v));
      if (details.old || details.new) {
          const keys = new Set([...(Object.keys(details.old || {})), ...(Object.keys(details.new || {}))]);
          const parts = [];
          keys.forEach(k => {
              const o = details.old ? details.old[k] : undefined;
              const n = details.new ? details.new[k] : undefined;
              if (JSON.stringify(o) !== JSON.stringify(n)) {
                  parts.push(`${fieldLabel[k] || k}: ${fmt(o)} → ${fmt(n)}`);
              }
          });
          return parts.length ? parts.join('  •  ') : 'No changes';
      }
      return Object.entries(details).map(([k, v]) => `${fieldLabel[k] || k}: ${fmt(v)}`).join('  •  ');
  };

  const handleOpenMap = (coords, label) => {
      setMapDialog({ lat: coords.lat, lng: coords.lng, label });
  };

  const handleSort = (field) => {
      const isAsc = sortBy === field && sortOrder === 'asc';
      setSortOrder(isAsc ? 'desc' : 'asc');
      setSortBy(field);
  };

  const sortedAttendance = [...attendance].sort((a, b) => {
      const av = a[sortBy];
      const bv = b[sortBy];
      const aStr = (av == null || av === '-') ? '' : String(av);
      const bStr = (bv == null || bv === '-') ? '' : String(bv);
      let cmp = 0;
      if (aStr < bStr) cmp = -1;
      else if (aStr > bStr) cmp = 1;
      return sortOrder === 'asc' ? cmp : -cmp;
  });

  const renderSortableHeader = (label, field) => (
      <TableCell
          sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}
          sortDirection={sortBy === field ? sortOrder : false}
      >
          <TableSortLabel
              active={sortBy === field}
              direction={sortBy === field ? sortOrder : 'asc'}
              onClick={() => handleSort(field)}
          >
              {label}
          </TableSortLabel>
      </TableCell>
  );

  const buildDateTime = (date, time) => {
      if (!date || !time) return null;
      return `${date}T${time}:00`;
  };

  const assignedLocationFrom = (lat, lng) => {
      if (lat == null || lng == null) return '';
      return `${lat}, ${lng}`;
  };

  const matchedLocationName = (coordStr) => {
      const loc = editUserLocations.find(l => coordMatchesLocation(coordStr, l.latitude, l.longitude));
      return loc ? (loc.punch_location_name || loc.address || '') : '';
  };

  const handleEditClick = async (row) => {
      const inOnSite = row.check_in_on_site === true;
      const outOnSite = row.check_out_on_site === true;
      setEditData({
          id: row.id,
          date: row.date || '',
          check_in: row.check_in && row.check_in !== '-' ? row.check_in.slice(0, 5) : '',
          check_in_location: row.check_in_location && row.check_in_location !== '-' ? row.check_in_location : '',
          use_assigned_in: inOnSite,
          selectedAssignedIn: '',
          check_out: row.check_out && row.check_out !== '-' ? row.check_out.slice(0, 5) : '',
          check_out_location: row.check_out_location && row.check_out_location !== '-' ? row.check_out_location : '',
          use_assigned_out: outOnSite,
          selectedAssignedOut: '',
          effective_lat: row.effective_lat,
          effective_lng: row.effective_lng
      });
      setEditOpen(true);

      try {
          const res = await axios.get(`${API_URL}/punching/locations`, { headers });
          const userLocs = res.data.filter(l => l.user_id === row.user_id);
          setEditUserLocations(userLocs);
      } catch (err) {
          setEditUserLocations([]);
      }
  };

  const handleCheckInOnSite = (checked) => {
      setEditData(prev => {
          const loc = editUserLocations[0];
          return {
              ...prev,
              use_assigned_in: checked,
              check_in_location: checked ? assignedLocationFrom(loc?.latitude, loc?.longitude) : '',
              selectedAssignedIn: checked ? (loc?.id || '') : ''
          };
      });
  };

  const handleCheckOutOnSite = (checked) => {
      setEditData(prev => {
          const loc = editUserLocations[0];
          return {
              ...prev,
              use_assigned_out: checked,
              check_out_location: checked ? assignedLocationFrom(loc?.latitude, loc?.longitude) : '',
              selectedAssignedOut: checked ? (loc?.id || '') : ''
          };
      });
  };

  const handleSelectAssignedIn = (locId) => {
      const loc = editUserLocations.find(l => l.id === locId);
      setEditData(prev => ({
          ...prev,
          selectedAssignedIn: locId,
          check_in_location: loc ? assignedLocationFrom(loc.latitude, loc.longitude) : ''
      }));
  };

  const handleSelectAssignedOut = (locId) => {
      const loc = editUserLocations.find(l => l.id === locId);
      setEditData(prev => ({
          ...prev,
          selectedAssignedOut: locId,
          check_out_location: loc ? assignedLocationFrom(loc.latitude, loc.longitude) : ''
      }));
  };

  const handleRemoveCheckIn = () => {
      setEditData(prev => ({ ...prev, check_in: '', check_in_location: '', use_assigned_in: false }));
  };

  const handleRemoveCheckOut = () => {
      setEditData(prev => ({ ...prev, check_out: '', check_out_location: '', use_assigned_out: false }));
  };

  const handleUpdateRecord = async () => {
      setUpdating(true);
      try {
          const payload = {
              check_in: buildDateTime(editData.date, editData.check_in),
              check_in_location: editData.check_in_location || null,
              check_out: buildDateTime(editData.date, editData.check_out),
              check_out_location: editData.check_out_location || null
          };
          await axios.put(`${API_URL}/punching/attendance/${editData.id}`, payload, { headers });
          setAttendance(prev => prev.map(p => p.id === editData.id ? {
              ...p,
              check_in: editData.check_in ? editData.check_in + ':00' : '-',
              check_in_location: editData.check_in_location || '-',
              check_in_on_site: null,
              check_out: editData.check_out ? editData.check_out + ':00' : '-',
              check_out_location: editData.check_out_location || '-',
              check_out_on_site: null
          } : p));
          setEditOpen(false);
      } catch (err) {
          console.error(err);
          alert('Error updating record');
      } finally {
          setUpdating(false);
      }
  };

  const handleOpenAddPunch = () => {
      setAddPunchData({
          user_id: null,
          date: new Date().toISOString().slice(0, 10),
          check_in: '',
          check_in_location: '',
          check_out: '',
          check_out_location: ''
      });
      setAddPunchOpen(true);
  };

  const handleAddPunch = async () => {
      if (!addPunchData.user_id) return alert('Select a user');
      if (!addPunchData.date) return alert('Select a date');
      if (!addPunchData.check_in && !addPunchData.check_out) return alert('Provide at least In or Out time');
      setLoading(true);
      try {
          await axios.post(`${API_URL}/punching/attendance/record`, {
              user_id: addPunchData.user_id,
              date: addPunchData.date,
              check_in: addPunchData.check_in ? `${addPunchData.date}T${addPunchData.check_in}:00` : null,
              check_in_location: addPunchData.check_in_location || null,
              check_out: addPunchData.check_out ? `${addPunchData.date}T${addPunchData.check_out}:00` : null,
              check_out_location: addPunchData.check_out_location || null
          }, { headers });
          setAddPunchOpen(false);
          fetchAttendance();
      } catch (err) {
          console.error(err);
          alert('Error adding punch');
      } finally {
          setLoading(false);
      }
  };

  const handleAddPunchUserChange = async (v) => {
      setAddPunchData(prev => ({ ...prev, user_id: v ? v.id : null, use_assigned_in: false, selectedAssignedIn: '', use_assigned_out: false, selectedAssignedOut: '', check_in_location: '', check_out_location: '' }));
      if (v) {
          try {
              const res = await axios.get(`${API_URL}/punching/locations`, { headers });
              setAddPunchUserLocations(res.data.filter(l => l.user_id === v.id));
          } catch (err) {
              setAddPunchUserLocations([]);
          }
      } else {
          setAddPunchUserLocations([]);
      }
  };

  const handleAddCheckInOnSite = (checked) => {
      setAddPunchData(prev => {
          const loc = addPunchUserLocations[0];
          return { ...prev, use_assigned_in: checked, check_in_location: checked ? assignedLocationFrom(loc?.latitude, loc?.longitude) : '', selectedAssignedIn: checked ? (loc?.id || '') : '' };
      });
  };

  const handleAddCheckOutOnSite = (checked) => {
      setAddPunchData(prev => {
          const loc = addPunchUserLocations[0];
          return { ...prev, use_assigned_out: checked, check_out_location: checked ? assignedLocationFrom(loc?.latitude, loc?.longitude) : '', selectedAssignedOut: checked ? (loc?.id || '') : '' };
      });
  };

  const handleAddSelectAssignedIn = (locId) => {
      const loc = addPunchUserLocations.find(l => l.id === locId);
      setAddPunchData(prev => ({ ...prev, selectedAssignedIn: locId, check_in_location: loc ? assignedLocationFrom(loc.latitude, loc.longitude) : '' }));
  };

  const handleAddSelectAssignedOut = (locId) => {
      const loc = addPunchUserLocations.find(l => l.id === locId);
      setAddPunchData(prev => ({ ...prev, selectedAssignedOut: locId, check_out_location: loc ? assignedLocationFrom(loc.latitude, loc.longitude) : '' }));
  };

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden', boxSizing: 'border-box', pb: 6, px: { xs: 1, md: 3 }, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
      
      {/* Modern Gradient Header */}
      <Grow in={true} timeout={500}>
        <Box sx={{ 
            mb: 4, 
            mt: 2, 
            p: 4, 
            borderRadius: 4, 
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
            color: 'white',
            boxShadow: '0 10px 30px rgba(30, 60, 114, 0.2)',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            gap: 3
        }}>
            <Box sx={{ position: 'relative', zIndex: 2 }}>
                <Typography variant="h4" fontWeight="800" sx={{ mb: 1, letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 2, color: 'white' }}>
                    <LocationOnIcon sx={{ fontSize: 36, color: '#90caf9' }} />
                    Punching Assignments
                </Typography>
                <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                    Manage and track work locations and assignments
                </Typography>
            </Box>
            
            <Box sx={{ position: 'relative', zIndex: 2, display: 'flex', gap: 2 }}>
              <Button 
                  variant="outlined"
                  onClick={handleOpenManage}
                  sx={{ 
                      borderRadius: 2, fontWeight: 'bold', px: 3, py: 1,
                      borderColor: 'rgba(255,255,255,0.4)', color: 'white',
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', borderColor: 'white' }
                  }}
              >
                  Manage Locations
              </Button>
              <Button 
                  variant="contained" 
                  startIcon={<AddIcon />} 
                  onClick={() => {
                    setAssignMode('select');
                    setSelectedPunchLocations([]);
                    setAddress('');
                    setOpen(true);
                  }}
                  sx={{ 
                      borderRadius: 2, fontWeight: 'bold', px: 3, py: 1,
                      bgcolor: 'white', color: '#1e3c72',
                      boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
                      '&:hover': { bgcolor: '#f1f5f9', transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(0,0,0,0.15)' }
                  }}
              >
                  New Assignment
              </Button>
            </Box>
            
            {/* Decorative background circles */}
            <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
            <Box sx={{ position: 'absolute', bottom: -100, right: 100, width: 250, height: 250, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
        </Box>
      </Grow>

      {/* Filters and Controls */}
      <Card elevation={0} sx={{ mb: 4, borderRadius: 4, border: '1px solid #e2e8f0', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', overflow: 'hidden' }}>
        <Box sx={{ px: 3, py: 1.5, bgcolor: '#f8fafc', borderBottom: '1px solid #eef2f7', display: 'flex', alignItems: 'center', gap: 1 }}>
            <FilterListIcon sx={{ fontSize: 20, color: '#64748b' }} />
            <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#475569', letterSpacing: 0.5, textTransform: 'uppercase', fontSize: '0.75rem' }}>
                Filters
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {(searchTerm || countryFilter || locationFilter || filterFrom || filterTo) && (
                <Button
                    size="small"
                    onClick={clearFilters}
                    sx={{ textTransform: 'none', fontWeight: 'bold', color: '#2563eb', borderRadius: 2, '&:hover': { bgcolor: '#eff6ff' } }}
                >
                    Clear All
                </Button>
            )}
        </Box>
        <Box sx={{ p: 2, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
                <TextField
                    label="From"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filterFrom}
                    onChange={(e) => setFilterFrom(e.target.value)}
                    sx={{
                        minWidth: 160,
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            '& fieldset': { borderColor: '#e2e8f0' }
                        }
                    }}
                />
                <TextField
                    label="To"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filterTo}
                    onChange={(e) => setFilterTo(e.target.value)}
                    sx={{
                        minWidth: 160,
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            '& fieldset': { borderColor: '#e2e8f0' }
                        }
                    }}
                />
                <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 180 } }}>
                    <InputLabel id="country-filter-label">Country</InputLabel>
                    <Select
                        labelId="country-filter-label"
                        label="Country"
                        value={countryFilter}
                        onChange={e => setCountryFilter(e.target.value)}
                        sx={{
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            '& fieldset': { borderColor: '#e2e8f0' },
                            '&:hover fieldset': { borderColor: '#cbd5e1' },
                            '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                        }}
                    >
                        <MenuItem value="">All Countries</MenuItem>
                        {allCountries.map(c => (
                            <MenuItem key={c} value={c}>{c}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: { xs: '100%', sm: 180 } }}>
                    <InputLabel id="location-filter-label">Location</InputLabel>
                    <Select
                        labelId="location-filter-label"
                        label="Location"
                        value={locationFilter}
                        onChange={e => setLocationFilter(e.target.value)}
                        sx={{
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            '& fieldset': { borderColor: '#e2e8f0' },
                            '&:hover fieldset': { borderColor: '#cbd5e1' },
                            '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                        }}
                    >
                        <MenuItem value="">All Locations</MenuItem>
                        {allLocationNames.map(l => (
                            <MenuItem key={l} value={l}>{l}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    onClick={handleExport}
                    sx={{ borderRadius: 2, fontWeight: 'bold', px: 3, borderColor: '#e2e8f0', color: '#475569', '&:hover': { bgcolor: '#f8fafc', borderColor: '#cbd5e1' }, height: '40px' }}
                >
                    Export CSV
                </Button>
                <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    onClick={handleExportBC}
                    sx={{ borderRadius: 2, fontWeight: 'bold', px: 3, borderColor: '#2563eb', color: '#2563eb', '&:hover': { bgcolor: '#eff6ff', borderColor: '#1d4ed8' }, height: '40px' }}
                >
                    Export BC
                </Button>
                {activeTab === 1 && (
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleOpenAddPunch}
                        sx={{ borderRadius: 2, fontWeight: 'bold', px: 3, height: '40px' }}
                    >
                        Add Punch
                    </Button>
                )}
                <TextField 
                    placeholder="Search User or Location..." 
                    size="small" 
                    value={searchTerm} 
                    onChange={e => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: '#94a3b8' }} /></InputAdornment>
                    }}
                    sx={{ 
                        flexGrow: 1, 
                        minWidth: { sm: 250 },
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#f8fafc',
                            borderRadius: 2,
                            '& fieldset': { borderColor: '#e2e8f0' },
                            '&:hover fieldset': { borderColor: '#cbd5e1' },
                            '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '1px' },
                        }
                    }}
                />
        </Box>
      </Card>

      <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          sx={{
              mb: 3,
              bgcolor: 'white',
              borderRadius: 3,
              border: '1px solid #e2e8f0',
              px: 1,
              minHeight: '48px',
              '& .MuiTab-root': { fontWeight: 'bold', textTransform: 'none', minHeight: '48px' },
              '& .Mui-selected': { color: '#1e3c72' },
              '& .MuiTabs-indicator': { backgroundColor: '#1e3c72' }
          }}
      >
          <Tab label="Assignments" />
          <Tab label="Attendance" />
          <Tab label="Audit" />
      </Tabs>

      {activeTab === 0 && (filteredLocations.length === 0 ? (
          <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
              <Typography color="text.secondary">No users assigned to locations yet or no matches found.</Typography>
          </Paper>
      ) : (
          <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, border: '1px solid #f1f5f9', overflowX: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>User</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>Punching ID</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>Locations</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }} align="right">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                                        <TableBody>
                        {filteredLocations.map((group) => (
                            <TableRow
                                key={group.user_id}
                                sx={{ cursor: 'pointer', transition: 'all 0.2s ease', '&:hover': { bgcolor: '#f1f5f9' }, '&:last-child td, &:last-child th': { border: 0 } }}
                                onClick={() => handleUserClick(group.user_id)}
                            >
                                <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <Avatar sx={{ width: 36, height: 36, background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', fontSize: '0.9rem', fontWeight: 'bold' }}>
                                            {group.user_name ? group.user_name.charAt(0) : '?'}
                                        </Avatar>
                                        <Typography variant="body2" fontWeight="600" color="#1e293b">{group.user_name}</Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" sx={{ fontFamily: 'monospace', bgcolor: '#f1f5f9', px: 1, py: 0.5, borderRadius: 1, color: '#1e3c72', fontWeight: 'bold', display: 'inline-block' }}>
                                        {group.userpunchingid || '—'}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                                        {group.locations.map(loc => (
                                            <Box key={loc.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                                <LocationOnIcon sx={{ color: '#94a3b8', fontSize: 16 }} />
                                                {loc.punch_location_name && (
                                                    <Chip label={loc.punch_location_name} size="small" color="primary" sx={{ fontSize: '0.7rem', height: 20 }} />
                                                )}
                                                <Typography variant="caption" sx={{ fontFamily: 'monospace', bgcolor: '#f8fafc', px: 1, py: 0.5, borderRadius: 1, color: '#475569', fontWeight: 'bold' }}>
                                                    {loc.latitude?.toFixed(6) || '—'}, {loc.longitude?.toFixed(6) || '—'}
                                                </Typography>
                                                <IconButton
                                                    size="small"
                                                    sx={{ color: '#ef4444', bgcolor: '#fef2f2', '&:hover': { bgcolor: '#fee2e2' }, ml: 'auto' }}
                                                    onClick={(e) => { e.stopPropagation(); handleDelete(loc.id); }}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        ))}
                                    </Box>
                                </TableCell>
                                <TableCell align="right">
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={(e) => { e.stopPropagation(); handleUserClick(group.user_id); }}
                                        sx={{ borderRadius: 2, fontWeight: 'bold', minWidth: '80px', '&:hover': { bgcolor: '#eff6ff', borderColor: '#3b82f6' } }}
                                    >
                                        Details
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
          </TableContainer>
      ))}

      {activeTab === 1 && (attendanceLoading ? (
          <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
              <Typography color="text.secondary">Loading attendance records...</Typography>
          </Paper>
      ) : attendance.length === 0 ? (
          <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
              <Typography color="text.secondary">No attendance records found for the selected filters.</Typography>
          </Paper>
      ) : (
          <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, border: '1px solid #f1f5f9', overflowX: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
              <Table sx={{ minWidth: 1200 }}>
                  <TableHead sx={{ bgcolor: '#f8fafc' }}>
                      <TableRow>
                          {renderSortableHeader('Date', 'date')}
                          {renderSortableHeader('In Time', 'check_in')}
                          {renderSortableHeader('In On Location', 'check_in_on_site')}
                          {renderSortableHeader('Out Time', 'check_out')}
                          {renderSortableHeader('Out On Location', 'check_out_on_site')}
                          {renderSortableHeader('User', 'user_name')}
                          {renderSortableHeader('Punching ID', 'userpunchingid')}
                          {renderSortableHeader('Location', 'punch_location_name')}
                          {renderSortableHeader('Address', 'address')}
                          <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }} align="right">Actions</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                      {sortedAttendance.map((r) => (
                          <TableRow key={r.id} sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { bgcolor: '#f8fafc' } }}>
                              <TableCell><Typography variant="body2" fontWeight="600">{r.date}</Typography></TableCell>
                              <TableCell><Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{r.check_in}</Typography></TableCell>
                              <TableCell>{renderOnSite(r.check_in_on_site, r.punch_location_name)}</TableCell>
                              <TableCell><Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{r.check_out}</Typography></TableCell>
                              <TableCell>{renderOnSite(r.check_out_on_site, r.punch_location_name)}</TableCell>
                              <TableCell><Typography variant="body2" fontWeight="600">{r.user_name}</Typography></TableCell>
                              <TableCell><Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{r.userpunchingid || '—'}</Typography></TableCell>
                              <TableCell><Typography variant="body2">{r.punch_location_name || '—'}</Typography></TableCell>
                              <TableCell><Typography variant="body2" color="text.secondary">{r.address || '—'}</Typography></TableCell>
                              <TableCell align="right">
                                  <IconButton
                                      size="small"
                                      onClick={() => handleEditClick(r)}
                                      sx={{ color: '#2563eb', bgcolor: '#eff6ff', '&:hover': { bgcolor: '#dbeafe' } }}
                                  >
                                      <EditIcon fontSize="small" />
                                  </IconButton>
                              </TableCell>
                          </TableRow>
                      ))}
                  </TableBody>
              </Table>
          </TableContainer>
      ))}

      {activeTab === 2 && (auditLoading ? (
          <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
              <Typography color="text.secondary">Loading audit log...</Typography>
          </Paper>
      ) : audit.length === 0 ? (
          <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: '#f8fafc' }}>
              <Typography color="text.secondary">No audit records yet.</Typography>
          </Paper>
      ) : (
          <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 4, border: '1px solid #f1f5f9', overflowX: 'auto', boxShadow: '0 4px 20px rgba(0,0,0,0.03)' }}>
              <Table sx={{ minWidth: 900 }}>
                  <TableHead sx={{ bgcolor: '#f8fafc' }}>
                      <TableRow>
                          <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>Date / Time</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>Action</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>Performed By</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>User</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: '#475569', py: 2 }}>Details</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                      {audit.map((a) => (
                          <TableRow key={a.id} sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { bgcolor: '#f8fafc' } }}>
                              <TableCell><Typography variant="body2" sx={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{formatAuditDate(a.created_at)}</Typography></TableCell>
                              <TableCell><Chip label={auditActionLabel(a.action)} size="small" color={auditActionColor(a.action)} sx={{ fontWeight: 'bold', fontSize: '0.7rem' }} /></TableCell>
                              <TableCell><Typography variant="body2" fontWeight="600">{a.user_name}</Typography></TableCell>
                              <TableCell><Typography variant="body2">{a.target_user_name || '—'}</Typography></TableCell>
                              <TableCell><Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460 }}>{renderAuditDetails(a.details)}</Typography></TableCell>
                          </TableRow>
                      ))}
                  </TableBody>
              </Table>
          </TableContainer>
      ))}

      {/* Add Assignment Dialog */}
      <Dialog 
        open={open} 
        onClose={() => setOpen(false)} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
            sx: { borderRadius: 4, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' }
        }}
      >
        <DialogTitle sx={{ 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
            color: 'white',
            display: 'flex', 
            alignItems: 'center', 
            gap: 1.5,
            p: 3
        }}>
            <LocationOnIcon /> Assign Work Location
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc' }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="overline" color="text.secondary" fontWeight="800" sx={{ mb: 1, display: 'block' }}>USER</Typography>
                        <Autocomplete
                            options={users}
                            getOptionLabel={(option) => option.name || ''}
                            value={selectedUser}
                            onChange={(event, newValue) => setSelectedUser(newValue)}
                            renderInput={(params) => <TextField {...params} label="Search User" fullWidth sx={{ bgcolor: 'white' }} />}
                        />
                    </Box>
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="overline" color="text.secondary" fontWeight="800" sx={{ mb: 1, display: 'block' }}>PUNCHING ID</Typography>
                        <TextField
                            label="User Punching ID"
                            fullWidth
                            value={userPunchingId}
                            onChange={e => setUserPunchingId(e.target.value)}
                            placeholder="e.g. EMP-001"
                            sx={{ bgcolor: 'white', mb: 2 }}
                        />
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="overline" color="text.secondary" fontWeight="800" sx={{ mb: 1, display: 'block' }}>LOCATION MODE</Typography>
                        <Tabs
                          value={assignMode}
                          onChange={(e, v) => { setAssignMode(v); setSelectedPunchLocations([]); }}
                          sx={{ mb: 2, minHeight: 'auto', '& .MuiTab-root': { minHeight: 'auto', py: 1, px: 1.5, fontSize: '0.75rem', fontWeight: 'bold' } }}
                        >
                          <Tab label="Saved Location" value="select" />
                          <Tab label="Custom Pin" value="custom" />
                        </Tabs>

                        {assignMode === 'select' ? (
                          <Autocomplete
                              multiple
                              options={punchLocations}
                              getOptionLabel={(opt) => `${opt.name} (${opt.latitude?.toFixed(4)}, ${opt.longitude?.toFixed(4)})`}
                              value={selectedPunchLocations}
                              onChange={(e, v) => setSelectedPunchLocations(v)}
                              renderInput={(params) => <TextField {...params} label="Select Locations" fullWidth sx={{ bgcolor: 'white' }} />}
                          />
                        ) : (
                          <Box sx={{ p: 2, bgcolor: '#eff6ff', borderRadius: 2, border: '1px solid #bfdbfe' }}>
                              <Typography variant="caption" color="#2563eb" fontWeight="bold" display="block">SELECTED COORDINATES</Typography>
                              <Typography variant="body2" fontWeight="800" sx={{ mt: 0.5, color: '#1e3a8a' }}>{newLocation.lat.toFixed(6)}, {newLocation.lng.toFixed(6)}</Typography>
                              <Typography variant="caption" sx={{ mt: 1, display: 'block', color: '#3b82f6' }}>
                                  Click on the map to drop a pin.
                              </Typography>
                          </Box>
                        )}
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="overline" color="text.secondary" fontWeight="800" sx={{ mb: 1, display: 'block' }}>ADDRESS (optional)</Typography>
                        <TextField 
                            fullWidth 
                            label="Address / notes" 
                            value={address} 
                            onChange={e => setAddress(e.target.value)}
                            placeholder={assignMode === 'select' && selectedPunchLocations.length > 0 ? 'Inherited from selected locations' : 'e.g. Main Office, Site A'}
                            sx={{ bgcolor: 'white' }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Typography variant="overline" color="text.secondary" fontWeight="800" sx={{ mb: 1, display: 'block' }}>MAP {assignMode === 'select' && selectedPunchLocations.length > 0 ? '(preview)' : 'PIN'}</Typography>
                    <Box sx={{ height: 400, borderRadius: 3, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                        <MapContainer
                          center={
                            assignMode === 'select' && selectedPunchLocations.length > 0
                              ? [selectedPunchLocations[0].latitude, selectedPunchLocations[0].longitude]
                              : [25, 45]
                          }
                          zoom={assignMode === 'select' && selectedPunchLocations.length > 0 ? (selectedPunchLocations.length > 1 ? 6 : 15) : 4}
                          style={{ height: '100%', width: '100%' }}
                        >
                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                            {assignMode === 'select' && selectedPunchLocations.length > 0 ? (
                              selectedPunchLocations.map(ploc => (
                                <Marker key={ploc.id} position={[ploc.latitude, ploc.longitude]}>
                                  <Popup>{ploc.name}</Popup>
                                </Marker>
                              ))
                            ) : (
                              <LocationMarker position={newLocation} setPosition={setNewLocation} />
                            )}
                        </MapContainer>
                    </Box>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}>
            <Button onClick={() => setOpen(false)} sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Cancel</Button>
            <Button variant="contained" onClick={handleSave} disabled={loading} sx={{ borderRadius: 2, px: 3, fontWeight: 'bold' }}>
                {loading ? 'Saving...' : 'Save Assignment'}
            </Button>
        </DialogActions>
      </Dialog>

      {/* Manage Locations Dialog */}
      <Dialog 
        open={manageOpen} 
        onClose={() => setManageOpen(false)} 
        maxWidth="md" 
        fullWidth
        PaperProps={{ sx: { borderRadius: 4, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
      >
        <DialogTitle sx={{ 
            fontWeight: '800', 
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
            color: 'white',
            display: 'flex', 
            alignItems: 'center', 
            gap: 1.5,
            p: 3
        }}>
            <LocationOnIcon /> Manage Saved Locations
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc' }}>
          <Tabs value={manageTab} onChange={(e, v) => setManageTab(v)} sx={{ mb: 2 }}>
            <Tab label="Locations List" />
            <Tab label={editingPunchLoc ? 'Edit Location' : 'Add Location'} />
          </Tabs>

          {manageTab === 0 && (
            <>
              {punchLocations.length === 0 ? (
                <Paper elevation={0} sx={{ p: 4, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 2 }}>
                  <Typography color="text.secondary">No saved locations yet. Switch to Add tab to create one.</Typography>
                </Paper>
              ) : (
                <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 2, border: '1px solid #f1f5f9' }}>
                  <Table size="small">
                    <TableHead sx={{ bgcolor: '#f8fafc' }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Coordinates</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Address</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {punchLocations.map(pl => (
                        <TableRow key={pl.id} hover>
                          <TableCell sx={{ fontWeight: 600 }}>{pl.name}</TableCell>
                          <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                            {pl.latitude?.toFixed(6)}, {pl.longitude?.toFixed(6)}
                          </TableCell>
                          <TableCell>{pl.address || '—'}</TableCell>
                          <TableCell align="right">
                            <IconButton size="small" onClick={() => handleEditPunchLoc(pl)} sx={{ color: '#3b82f6' }}>
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton size="small" onClick={() => handleDeletePunchLocation(pl.id)} sx={{ color: '#ef4444' }}>
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          )}

          {manageTab === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Location Name *"
                  fullWidth
                  value={punchLocForm.name}
                  onChange={e => setPunchLocForm({...punchLocForm, name: e.target.value})}
                  placeholder="e.g. Main Office, Site A"
                  sx={{ bgcolor: 'white', mb: 2 }}
                />
                <TextField
                  label="Address"
                  fullWidth
                  value={punchLocForm.address}
                  onChange={e => setPunchLocForm({...punchLocForm, address: e.target.value})}
                  sx={{ bgcolor: 'white', mb: 2 }}
                />
                <Box sx={{ p: 2, bgcolor: '#eff6ff', borderRadius: 2, border: '1px solid #bfdbfe', mb: 2 }}>
                  <Typography variant="caption" color="#2563eb" fontWeight="bold" display="block">COORDINATES</Typography>
                  <TextField
                    label="Latitude"
                    type="number"
                    fullWidth
                    value={punchLocForm.latitude}
                    onChange={e => setPunchLocForm({...punchLocForm, latitude: parseFloat(e.target.value) || 0})}
                    size="small"
                    sx={{ bgcolor: 'white', mt: 1 }}
                    inputProps={{ step: 0.000001 }}
                  />
                  <TextField
                    label="Longitude"
                    type="number"
                    fullWidth
                    value={punchLocForm.longitude}
                    onChange={e => setPunchLocForm({...punchLocForm, longitude: parseFloat(e.target.value) || 0})}
                    size="small"
                    sx={{ bgcolor: 'white', mt: 1 }}
                    inputProps={{ step: 0.000001 }}
                  />
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<MyLocationIcon />}
                    onClick={() => {
                      if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                          (pos) => {
                            setPunchLocForm(prev => ({
                              ...prev,
                              latitude: pos.coords.latitude,
                              longitude: pos.coords.longitude
                            }));
                          },
                          () => alert('Unable to retrieve your location. Please allow location access in your browser.'),
                          { enableHighAccuracy: true, timeout: 10000 }
                        );
                      } else {
                        alert('Geolocation is not supported by your browser.');
                      }
                    }}
                    sx={{ mt: 1, borderRadius: 2, fontWeight: 'bold', textTransform: 'none' }}
                  >
                    Use My Current Location
                  </Button>
                  <Typography variant="caption" sx={{ mt: 1, display: 'block', color: '#3b82f6' }}>
                    Click on the map to set coordinates, or type them directly.
                  </Typography>
                </Box>
                <Stack direction="row" spacing={2}>
                  <Button variant="contained" onClick={handleSavePunchLocation} sx={{ borderRadius: 2, fontWeight: 'bold' }}>
                    {editingPunchLoc ? 'Update' : 'Save'}
                  </Button>
                  <Button onClick={() => { setManageTab(0); setEditingPunchLoc(null); }} sx={{ color: 'text.secondary' }}>
                    Cancel
                  </Button>
                </Stack>
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography variant="overline" color="text.secondary" fontWeight="800" sx={{ mb: 1, display: 'block' }}>MAP PIN</Typography>
                <Box sx={{ height: 400, borderRadius: 3, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                  <MapContainer center={[punchLocForm.latitude, punchLocForm.longitude]} zoom={10} style={{ height: '100%', width: '100%' }}>
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <LocationMarker 
                      position={{ lat: punchLocForm.latitude, lng: punchLocForm.longitude }} 
                      setPosition={(pos) => setPunchLocForm(prev => ({ ...prev, latitude: pos.lat, longitude: pos.lng }))} 
                    />
                  </MapContainer>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}>
          <Button onClick={() => setManageOpen(false)} sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Map Preview Dialog */}
      <Dialog
          open={!!mapDialog}
          onClose={() => setMapDialog(null)}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: 4, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
      >
          <DialogTitle sx={{
              fontWeight: '800',
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 3
          }}>
              <LocationOnIcon /> Location on Map
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc' }}>
              {mapDialog && (
                  <>
                      <Typography variant="subtitle1" fontWeight="800" sx={{ mb: 1, color: '#1e3a8a' }}>
                          {mapDialog.label}: {mapDialog.lat.toFixed(6)}, {mapDialog.lng.toFixed(6)}
                      </Typography>
                      <Box sx={{ height: 400, borderRadius: 3, overflow: 'hidden', border: '1px solid #e2e8f0', width: '100%', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                          <MapContainer
                              center={[mapDialog.lat, mapDialog.lng]}
                              zoom={15}
                              style={{ height: '100%', width: '100%' }}
                          >
                              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                              <Marker position={[mapDialog.lat, mapDialog.lng]}>
                                  <Popup>
                                      {mapDialog.label}<br />{mapDialog.lat.toFixed(6)}, {mapDialog.lng.toFixed(6)}
                                  </Popup>
                              </Marker>
                              <MapResizer />
                          </MapContainer>
                      </Box>
                      <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                          <Button
                              variant="outlined"
                              startIcon={<LocationOnIcon />}
                              onClick={() => window.open(`https://www.google.com/maps?q=${mapDialog.lat},${mapDialog.lng}`, '_blank', 'noopener,noreferrer')}
                              sx={{ borderRadius: 2, fontWeight: 'bold' }}
                          >
                              Open in Google Maps
                          </Button>
                      </Box>
                  </>
              )}
          </DialogContent>
          <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
              <Button onClick={() => setMapDialog(null)} sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Close</Button>
          </DialogActions>
      </Dialog>

      {/* Edit Attendance Record Dialog */}
      <Dialog
          open={editOpen}
          onClose={() => setEditOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: 4, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
      >
          <DialogTitle sx={{
              fontWeight: '800',
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              p: 3
          }}>
              <EditIcon /> Edit Attendance Record
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc' }}>
              <Stack spacing={2} sx={{ mt: 1 }}>
                  <Box sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: 'white' }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                          <Typography variant="overline" color="text.secondary" fontWeight="800">CHECK IN</Typography>
                          <Button size="small" color="error" variant="outlined" startIcon={<DeleteIcon />} onClick={handleRemoveCheckIn} sx={{ borderRadius: 2, fontWeight: 'bold', textTransform: 'none' }}>
                              Remove
                          </Button>
                      </Stack>
                      <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  label="In Time"
                                  type="time"
                                  fullWidth
                                  value={editData.check_in}
                                  onChange={(e) => setEditData({...editData, check_in: e.target.value})}
                                  InputLabelProps={{ shrink: true }}
                                  sx={{ bgcolor: 'white' }}
                              />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                              <FormControlLabel
                                  control={<Switch checked={editData.use_assigned_in} onChange={(e, checked) => handleCheckInOnSite(checked)} />}
                                  label="On Site"
                              />
                          </Grid>
                          {editData.use_assigned_in && editUserLocations.length > 0 && (
                              <Grid item xs={12}>
                                  <FormControl fullWidth size="small">
                                      <InputLabel id="assigned-in-label">Assigned Location</InputLabel>
                                      <Select
                                          labelId="assigned-in-label"
                                          label="Assigned Location"
                                          value={editData.selectedAssignedIn || ''}
                                          onChange={(e) => handleSelectAssignedIn(e.target.value)}
                                          sx={{ bgcolor: 'white' }}
                                      >
                                          {editUserLocations.map(loc => (
                                              <MenuItem key={loc.id} value={loc.id}>
                                                  {loc.punch_location_name || loc.address || `Location ${loc.id}`}
                                              </MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>
                              </Grid>
                          )}
                          <Grid item xs={12}>
                              <TextField
                                  label="Location Coordinates"
                                  fullWidth
                                  value={editData.check_in_location}
                                  onChange={(e) => setEditData({...editData, check_in_location: e.target.value})}
                                  InputProps={{
                                      endAdornment: (
                                          <InputAdornment position="end">
                                              <IconButton
                                                  size="small"
                                                  onClick={() => {
                                                      const coords = parseCoordinates(editData.check_in_location);
                                                      if (coords) handleOpenMap(coords, 'Check-in');
                                                  }}
                                              >
                                                  <LocationOnIcon fontSize="small" />
                                              </IconButton>
                                          </InputAdornment>
                                      )
                                  }}
                                  sx={{ bgcolor: 'white' }}
                              />
                              {matchedLocationName(editData.check_in_location) && (
                                  <Typography variant="caption" sx={{ color: '#15803d', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                                      <LocationOnIcon sx={{ fontSize: 14 }} /> {matchedLocationName(editData.check_in_location)}
                                  </Typography>
                              )}
                          </Grid>
                      </Grid>
                  </Box>

                  <Box sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: 'white' }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                          <Typography variant="overline" color="text.secondary" fontWeight="800">CHECK OUT</Typography>
                          <Button size="small" color="error" variant="outlined" startIcon={<DeleteIcon />} onClick={handleRemoveCheckOut} sx={{ borderRadius: 2, fontWeight: 'bold', textTransform: 'none' }}>
                              Remove
                          </Button>
                      </Stack>
                      <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  label="Out Time"
                                  type="time"
                                  fullWidth
                                  value={editData.check_out}
                                  onChange={(e) => setEditData({...editData, check_out: e.target.value})}
                                  InputLabelProps={{ shrink: true }}
                                  sx={{ bgcolor: 'white' }}
                              />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                              <FormControlLabel
                                  control={<Switch checked={editData.use_assigned_out} onChange={(e, checked) => handleCheckOutOnSite(checked)} />}
                                  label="On Site"
                              />
                          </Grid>
                          {editData.use_assigned_out && editUserLocations.length > 0 && (
                              <Grid item xs={12}>
                                  <FormControl fullWidth size="small">
                                      <InputLabel id="assigned-out-label">Assigned Location</InputLabel>
                                      <Select
                                          labelId="assigned-out-label"
                                          label="Assigned Location"
                                          value={editData.selectedAssignedOut || ''}
                                          onChange={(e) => handleSelectAssignedOut(e.target.value)}
                                          sx={{ bgcolor: 'white' }}
                                      >
                                          {editUserLocations.map(loc => (
                                              <MenuItem key={loc.id} value={loc.id}>
                                                  {loc.punch_location_name || loc.address || `Location ${loc.id}`}
                                              </MenuItem>
                                          ))}
                                      </Select>
                                  </FormControl>
                              </Grid>
                          )}
                          <Grid item xs={12}>
                              <TextField
                                  label="Location Coordinates"
                                  fullWidth
                                  value={editData.check_out_location}
                                  onChange={(e) => setEditData({...editData, check_out_location: e.target.value})}
                                  InputProps={{
                                      endAdornment: (
                                          <InputAdornment position="end">
                                              <IconButton
                                                  size="small"
                                                  onClick={() => {
                                                      const coords = parseCoordinates(editData.check_out_location);
                                                      if (coords) handleOpenMap(coords, 'Check-out');
                                                  }}
                                              >
                                                  <LocationOnIcon fontSize="small" />
                                              </IconButton>
                                          </InputAdornment>
                                      )
                                  }}
                                  sx={{ bgcolor: 'white' }}
                              />
                              {matchedLocationName(editData.check_out_location) && (
                                  <Typography variant="caption" sx={{ color: '#15803d', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                                      <LocationOnIcon sx={{ fontSize: 14 }} /> {matchedLocationName(editData.check_out_location)}
                                  </Typography>
                              )}
                          </Grid>
                      </Grid>
                  </Box>
              </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}>
              <Button onClick={() => setEditOpen(false)} sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Cancel</Button>
              <Button variant="contained" onClick={handleUpdateRecord} disabled={updating} sx={{ borderRadius: 2, px: 3, fontWeight: 'bold' }}>
                  {updating ? 'Updating...' : 'Update'}
              </Button>
          </DialogActions>
      </Dialog>
      {/* Add Punch Dialog */}
      <Dialog
          open={addPunchOpen}
          onClose={() => setAddPunchOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: 4, boxShadow: '0 10px 40px rgba(0,0,0,0.1)' } }}
      >
          <DialogTitle sx={{ fontWeight: '800', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', color: 'white', display: 'flex', alignItems: 'center', gap: 1.5, p: 3 }}>
              <AddIcon /> Add Punch
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc' }}>
              <Stack spacing={2} sx={{ mt: 1 }}>
                  <Autocomplete
                      options={users}
                      getOptionLabel={(option) => option.name || ''}
                      value={users.find(u => u.id === addPunchData.user_id) || null}
                      onChange={(e, v) => handleAddPunchUserChange(v)}
                      renderInput={(params) => <TextField {...params} label="User" fullWidth sx={{ bgcolor: 'white' }} />}
                  />
                  <TextField
                      label="Date"
                      type="date"
                      fullWidth
                      value={addPunchData.date}
                      onChange={(e) => setAddPunchData({...addPunchData, date: e.target.value})}
                      InputLabelProps={{ shrink: true }}
                      sx={{ bgcolor: 'white' }}
                  />
                  <Grid container spacing={2}>
                      <Grid item xs={6}>
                          <TextField
                              label="In Time"
                              type="time"
                              fullWidth
                              value={addPunchData.check_in}
                              onChange={(e) => setAddPunchData({...addPunchData, check_in: e.target.value})}
                              InputLabelProps={{ shrink: true }}
                              sx={{ bgcolor: 'white' }}
                          />
                      </Grid>
                      <Grid item xs={6}>
                          <TextField
                              label="Out Time"
                              type="time"
                              fullWidth
                              value={addPunchData.check_out}
                              onChange={(e) => setAddPunchData({...addPunchData, check_out: e.target.value})}
                              InputLabelProps={{ shrink: true }}
                              sx={{ bgcolor: 'white' }}
                          />
                      </Grid>
                  </Grid>
                  <Box sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: 'white' }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography variant="overline" color="text.secondary" fontWeight="800">CHECK IN</Typography>
                          <FormControlLabel control={<Switch checked={addPunchData.use_assigned_in} onChange={(e, checked) => handleAddCheckInOnSite(checked)} />} label="On Site" />
                      </Stack>
                      {addPunchData.use_assigned_in && addPunchUserLocations.length > 0 && (
                          <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                              <InputLabel id="add-assigned-in-label">Assigned Location</InputLabel>
                              <Select labelId="add-assigned-in-label" label="Assigned Location" value={addPunchData.selectedAssignedIn || ''} onChange={(e) => handleAddSelectAssignedIn(e.target.value)} sx={{ bgcolor: 'white' }}>
                                  {addPunchUserLocations.map(loc => (<MenuItem key={loc.id} value={loc.id}>{loc.punch_location_name || loc.address || `Location ${loc.id}`}</MenuItem>))}
                              </Select>
                          </FormControl>
                      )}
                      {!addPunchData.use_assigned_in && (
                          <Box sx={{ height: 200, borderRadius: 2, overflow: 'hidden', border: '1px solid #e2e8f0', mb: 1 }}>
                              <MapContainer center={(() => { const p = parseCoordinates(addPunchData.check_in_location); return p ? [p.lat, p.lng] : [25, 45]; })()} zoom={parseCoordinates(addPunchData.check_in_location) ? 15 : 6} style={{ height: '100%', width: '100%' }}>
                                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                  <LocationMarker position={(() => { const p = parseCoordinates(addPunchData.check_in_location); return p ? { lat: p.lat, lng: p.lng } : null; })()} setPosition={(pos) => setAddPunchData(prev => ({ ...prev, check_in_location: `${pos.lat}, ${pos.lng}` }))} />
                              </MapContainer>
                          </Box>
                      )}
                      <TextField label="In Location" fullWidth value={addPunchData.check_in_location} onChange={(e) => setAddPunchData({...addPunchData, check_in_location: e.target.value})} placeholder="lat, lng" sx={{ bgcolor: 'white' }} />
                  </Box>
                  <Box sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: 2, bgcolor: 'white' }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Typography variant="overline" color="text.secondary" fontWeight="800">CHECK OUT</Typography>
                          <FormControlLabel control={<Switch checked={addPunchData.use_assigned_out} onChange={(e, checked) => handleAddCheckOutOnSite(checked)} />} label="On Site" />
                      </Stack>
                      {addPunchData.use_assigned_out && addPunchUserLocations.length > 0 && (
                          <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                              <InputLabel id="add-assigned-out-label">Assigned Location</InputLabel>
                              <Select labelId="add-assigned-out-label" label="Assigned Location" value={addPunchData.selectedAssignedOut || ''} onChange={(e) => handleAddSelectAssignedOut(e.target.value)} sx={{ bgcolor: 'white' }}>
                                  {addPunchUserLocations.map(loc => (<MenuItem key={loc.id} value={loc.id}>{loc.punch_location_name || loc.address || `Location ${loc.id}`}</MenuItem>))}
                              </Select>
                          </FormControl>
                      )}
                      {!addPunchData.use_assigned_out && (
                          <Box sx={{ height: 200, borderRadius: 2, overflow: 'hidden', border: '1px solid #e2e8f0', mb: 1 }}>
                              <MapContainer center={(() => { const p = parseCoordinates(addPunchData.check_out_location); return p ? [p.lat, p.lng] : [25, 45]; })()} zoom={parseCoordinates(addPunchData.check_out_location) ? 15 : 6} style={{ height: '100%', width: '100%' }}>
                                  <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                  <LocationMarker position={(() => { const p = parseCoordinates(addPunchData.check_out_location); return p ? { lat: p.lat, lng: p.lng } : null; })()} setPosition={(pos) => setAddPunchData(prev => ({ ...prev, check_out_location: `${pos.lat}, ${pos.lng}` }))} />
                              </MapContainer>
                          </Box>
                      )}
                      <TextField label="Out Location" fullWidth value={addPunchData.check_out_location} onChange={(e) => setAddPunchData({...addPunchData, check_out_location: e.target.value})} placeholder="lat, lng" sx={{ bgcolor: 'white' }} />
                  </Box>
              </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 3, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0', gap: 1 }}>
              <Button onClick={() => setAddPunchOpen(false)} sx={{ color: 'text.secondary', fontWeight: 'bold' }}>Cancel</Button>
              <Button variant="contained" onClick={handleAddPunch} disabled={loading} sx={{ borderRadius: 2, px: 3, fontWeight: 'bold' }}>
                  {loading ? 'Saving...' : 'Save'}
              </Button>
          </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Punching;